import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import HeaderLogin from '../../main/nav-login/HeaderLogin';
import Footer from '../../main/nav/Footer';
import Chart from "react-apexcharts";
import Biodata from '../component/Biodata';

export default function ProfilP() {
    const { id } = useParams();
    const grafik = useRef(null);
    const navigate = useNavigate();
    const [user, setUser] = useState('');
    const [data, setData] = useState([]);

    const gotoGrafik = () => grafik.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const fetchUser = async () => {
        const { data } = await axios.get(`/user-view/${id}`);
        if (data) {
            setUser(data);
        }
    };

    const fetchData = async () => {
        const { data } = await axios.get('/data-get');
        if (data) {
            setData(data);
        }
    };

    useEffect(() => {
        fetchData();
        fetchUser();
    }, [id]);

    const labels = ['Seminar', 'Buku', 'Paten', 'Jurnal', 'Prosiding', 'Laporan', 'Opini', 'Karya', 'Poster'];
    const values = [
        user?.seminar_count,
        user?.buku_count,
        user?.paten_count,
        user?.jurnal_count,
        user?.prosiding_count,
        user?.non_publish_count,
        user?.opini_count,
        user?.karya_count,
        user?.poster_count,
    ].map((value) => Number(value || 0));

    return (
        <div className="min-h-screen bg-slate-50 text-brand-navy">
            <HeaderLogin data={data} grafik={gotoGrafik} />

            <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
                <div className="grid gap-5 lg:grid-cols-4">
                    <Biodata user={user} />
                </div>

                <section ref={grafik} className="mt-6 rounded-lg border border-slate-200 bg-white p-5 shadow-soft">
                    <div className="mb-4">
                        <span className="text-xs font-extrabold uppercase tracking-normal text-brand-green">Ringkasan Publikasi</span>
                        <h2 className="mt-2 font-display text-2xl font-extrabold">Sebaran data publikasi</h2>
                    </div>
                    <Chart
                        options={{
                            chart: {
                                events: {
                                    dataPointSelection: (event, chartContext, config) => {
                                        navigate(`/public/profil/${id}/${config.w.config.labels[config.dataPointIndex]}`);
                                    }
                                },
                                toolbar: { show: false },
                            },
                            colors: ['#0b7a5f'],
                            plotOptions: {
                                bar: {
                                    horizontal: true,
                                    borderRadius: 6,
                                }
                            },
                            dataLabels: {
                                enabled: true
                            },
                            labels,
                            grid: {
                                xaxis: {
                                    lines: {
                                        show: true
                                    }
                                }
                            },
                            yaxis: {
                                reversed: false,
                                axisTicks: {
                                    show: true
                                }
                            },
                        }}
                        series={[{ data: values }]}
                        type="bar"
                        height="400"
                    />
                </section>
            </main>

            <div className="bg-brand-navy text-white">
                <Footer />
            </div>
        </div>
    );
}
